import React from "react";

import User from "../../../../../../components/User";
import { useUser } from "../../../../../../store/user/selectors";

import { IProps } from "./interfaces";
import { Wrapper, UserWrapper, Message, MessageWrapper } from "./styles";

const ChatMessage = ({ users, message: { message, user: userId } }: IProps) => {
    const user = useUser();
    const messageUser = users.find(u => u._id === userId) || "anonymous";
    const isOwnMessage = user._id === userId;
    return (
        <Wrapper>
            {!isOwnMessage && (
                <UserWrapper>
                    <User reversed user={messageUser} />
                </UserWrapper>
            )}
            <MessageWrapper isOwnMessage={isOwnMessage}>
                <Message isOwnMessage={isOwnMessage}>{message}</Message>
            </MessageWrapper>
        </Wrapper>
    );
}

export default ChatMessage;
